/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/DependsOn/DependsOnTable/Content",
  dataTable
  
}) {
  return (<React.Fragment
>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={dataTable}
/>
{children}
</React.Fragment>)
}